module.exports = __webpack_public_path__ + "img/chehulu7.c068bf61.jpg";